import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import CloseIcon from '@mui/icons-material/Close';
import MarkdownRenderer from './MarkdownRenderer';

interface DocumentViewDialogProps {
  title: string | null;
  contents: string | unknown;
  open: boolean;
  handleClose: () => void;
}

function DocumentViewDialog({ title, contents, open, handleClose }: DocumentViewDialogProps) {
  const titleText = title || '';
  const contentsText = typeof contents === 'string' 
    ? contents 
    : typeof contents === 'object' && contents !== null
    ? JSON.stringify(contents, null, 2)
    : String(contents || '');
  
  return (
    <Dialog onClose={handleClose} open={open} maxWidth='md'>
      <DialogTitle>
        <Grid container direction='row' alignItems='center'>
          <Grid size={11}>
            <b>{titleText}</b>
          </Grid>
          <Grid size={1} sx={{ maxWidth: '25px' }}>
            <IconButton aria-label='close' onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Box
          padding='10px'
          sx={{
            maxWidth: 800,
          }}
        >
          <Grid container spacing={2} sx={{ width: '100%' }}>
            <Grid size={12}>
              <MarkdownRenderer content={contentsText} />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
export default DocumentViewDialog;

